
import type { App } from 'vue'
import component from './Upload.vue'
const install = (app: App): void => {
	app.component(component.name, component)
}

export default {
	install,
	component
}
